module.exports = __webpack_public_path__ + "_assets/img/download_4.f7493631.png";